import {
  GetNamedElementBlockRulesResponse,
  NamedElementBlockRule,
} from '@fullstory/proto/fs/services/ingestion-settings';
import { combineReducers, createRequestReducer } from '@fullstory/redux-util';
import { NamedElementBlockRuleActions } from './actions';
import { NamedElementBlockRuleRequestTypes } from './types';

type State = NamedElementBlockRule[];
const noResults: NamedElementBlockRule[] = [];
function namedElementBlockRules(state: State = [], action: NamedElementBlockRuleActions): State {
  switch (action.type) {
    case NamedElementBlockRuleRequestTypes.GetAllNamedElementBlockRulesSuccess: {
      return action.data.namedElementBlockRules ?? noResults;
    }
    case NamedElementBlockRuleRequestTypes.UpdateNamedElementBlockRuleSuccess: {
      return action.data.namedElementBlockRules;
    }
    case NamedElementBlockRuleRequestTypes.DeleteNamedElementBlockRuleSuccess: {
      return action.data.namedElementBlockRules;
    }
    default:
      return state;
  }
}

export const getAllNamedElementBlockRules =
  createRequestReducer<GetNamedElementBlockRulesResponse>()(
    NamedElementBlockRuleRequestTypes.GetAllNamedElementBlockRulesRequest,
    NamedElementBlockRuleRequestTypes.GetAllNamedElementBlockRulesSuccess,
    NamedElementBlockRuleRequestTypes.GetAllNamedElementBlockRulesFailure,
  );

type RequestsState = {
  getAllNamedElementBlockRules: ReturnType<typeof getAllNamedElementBlockRules>;
};

type NamedElementBlockRulesReducerState = {
  namedElementBlockRules: ReturnType<typeof namedElementBlockRules>;
  requests: RequestsState;
};

export const namedElementBlockRuleReducer = combineReducers<NamedElementBlockRulesReducerState>({
  namedElementBlockRules,
  requests: combineReducers<RequestsState>({ getAllNamedElementBlockRules }),
});
